var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}}):(_vm.hasValue)?_c('chip',{attrs:{"payload":_vm.payload}}):_c('div',[_vm._v(" - ")])
}
var staticRenderFns = []

export { render, staticRenderFns }